import {
    RaikoBaseCardContainer,
    RaikoCategorySelect,
    RaikoGridOneColumn,
    RaikoSectionContainer, showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useParams} from "react-router-dom";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useEffect, useState} from "react";

import {TourismService} from "../../../serverService/tourism/TourismService";
import {TourismCategoryService} from "../../../serverService/tourism/TourismCategoryService";
import {LanguageHelper} from "../../../util/LanguageHelper";
import {MagazineCategoryParser as CategoryParser} from "../../magazineCategory/MagazineCategoryParser";

export function TourismPlaceCategory() {

    const {id: placeId} = useParams()

    const service = new TourismService();
    const serviceCategory = new TourismCategoryService();

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [selectedCategoryItems, setSelectedCategoryItems] = useState([])
    const [categoryItems, setCategoryItems] = useState([])
    const [categoryLoading, setCategoryLoading] = useState(false)

    const [actionButtonLoading, setActionButtonLoading] = useState(false)

    useEffect(() => {
        if (typeof service !== "undefined") {
            getCategoryInfo()
            getAllCategoryList()
        }
    }, [placeId]);

    function getCategoryInfo() {
        service.getTourismPlaceCategoryList(placeId)
            .then(response => {
                setSelectedCategoryItems([])

                response.map((item, index) => {
                    setSelectedCategoryItems(prevState => [
                        ...prevState,
                        {
                            id: item.id,
                            name: item.metaData.title,
                            slug: item.slug
                        }
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
        })
    }

    function prepareResponseInfo(items) {
        const _items = []
        items.map((item, index) => {
            _items.push({
                ...item,
                title: item.metaData.title,
                children: prepareResponseInfo(item.children),
            })
        })

        return _items;
    }

    function getAllCategoryList() {
        setCategoryLoading(true)
        serviceCategory.getCategoryListByLanguage(LanguageHelper.getLanguageCode())
            .then(response => {
                const _items = prepareResponseInfo(response);
                setCategoryItems(new CategoryParser(_items).getCategoryListParsed())
            }).catch(reason => {

        }).finally(_ => {
            setCategoryLoading(false)
        })
    }

    function handleUpdateCategory() {
        if (selectedCategoryItems.length > 0) {
            setActionButtonLoading(true)
            service.updateTourismPlaceCategory(
                placeId,
                selectedCategoryItems,
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                setActionButtonLoading(false)
            })
        } else {
            showWarningMessage("لطفا ابتدا دسته بندی مورد نظر را انتخاب نمایید.")
        }
    }

    return <RaikoBaseCardContainer>
        <RaikoSectionContainer
            title={"دسته بندی "}
            hasActionButton
            actionButtonOnclick={handleUpdateCategory}
            actionButtonLoadingState={actionButtonLoading}
        >
            <RaikoGridOneColumn>
                <RaikoCategorySelect
                    selectedCategoryItems={selectedCategoryItems}
                    setSelectedCategoryItems={setSelectedCategoryItems}
                    items={categoryItems}
                    loadingState={categoryLoading}
                />
            </RaikoGridOneColumn>
        </RaikoSectionContainer>
    </RaikoBaseCardContainer>


}